// extracted by mini-css-extract-plugin
module.exports = {"fq-contract":"index_fq-contract_3uQgH","notice":"index_notice_l7tZ5","title":"index_title_1LQbl","confirm-button":"index_confirm-button_1jyhk"};